import { lazy } from "react"

export const ProLanding = lazy(() => import("./proLading"))
